var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "md:col-span-1" }, [
    _c("div", { staticClass: "px-4 sm:px-0" }, [
      _c(
        "h3",
        { staticClass: "text-lg font-medium text-gray-900" },
        [_vm._t("title")],
        2
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-1 text-sm text-gray-600" },
        [_vm._t("description")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }